/**
 * Patrones de validación portados desde el portal legado AludraPortalEInvoice
 * (Views/Customer/_FormParticularCustomer.cshtml, _FormBusinessCustomer.cshtml,
 * Models/EditProductPayload.cs). Compartidos entre CustomerForm y ProductForm
 * para no duplicar los regex.
 *
 * Se corrige una coma suelta dentro de la clase de caracteres del regex de
 * identificación original (`[A-Z,0-9]`, sin intención de aceptar comas) y se
 * agrega el flag `i` porque, a diferencia de la vista Razor original, este
 * formulario no fuerza mayúsculas.
 */

/** Identificación (RUC/Cédula/Pasaporte) según formato DGI. */
export const TAX_ID_REGEX =
  /^[A-Z0-9]+$|^([A-Z]*[0-9]+)+?(-[0-9]+){1,4}$|^([0-9]+-)?[A-Z0-9]+?(-[0-9]+){1,4}$/i;

export const TAX_ID_MIN_LENGTH = 6;

/** DV: 2 a 4 dígitos numéricos (legado: minlength 2 / maxlength 4). */
export const TAX_ID_SUB_REGEX = /^\d{2,4}$/;

/** Nombre / razón social: sin etiquetas HTML ni espacios al inicio/final. */
export const NO_HTML_NAME_REGEX = /^(?!.*<[^>]*>)(?!\s)(?!.*\s$).*$/;

/** SKU de producto: alfanumérico + separadores comunes. */
export const SKU_REGEX = /^[a-zA-Z0-9\-/\s.,()_]+$/;
export const SKU_MAX_LENGTH = 50;
